import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";
import { Layers, Zap } from "lucide-react";

const MODES = [
    { key: "apps", icon: Layers, labelKey: "chatPage.modeToggle.apps", color: "#2563eb" },
    { key: "automations", icon: Zap, labelKey: "chatPage.modeToggle.automations", color: "#7c3aed" },
];

export default function ModeToggle({ mode, onModeChange }) {
    const { t } = useTranslation();
    return (
        <div className="inline-flex items-center bg-gray-100 rounded-full p-1 gap-1">
            {MODES.map(({ key, icon: Icon, labelKey, color }) => {
                const isActive = mode === key;
                return (
                    <button
                        key={key}
                        onClick={() => onModeChange(key)}
                        className="relative flex items-center gap-1.5 px-4 py-1.5 rounded-full text-sm font-medium transition-colors duration-200 cursor-pointer"
                        style={{ color: isActive ? "#fff" : "#6b7280" }}
                    >
                        {isActive && (
                            <motion.div
                                layoutId="modeTogglePill"
                                className="absolute inset-0 rounded-full"
                                style={{ backgroundColor: color }}
                                transition={{ type: "spring", stiffness: 400, damping: 30 }}
                            />
                        )}
                        <span className="relative z-10 flex items-center gap-1.5">
                            <Icon size={14} />
                            {t(labelKey)}
                        </span>
                    </button>
                );
            })}
        </div>
    );
}
